// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, maybe, anyOf } from "@altostra/type-validations";
import { number, string, boolean, nullValidation } from "@altostra/type-validations/lib/primitives";

const nullableNumber = anyOf(number, nullValidation);

export const isMobileAppLinkingAssignment = objectOf({
  id: string,
  hostname: string,
  hostType: string,
  channel: string,
  status: string,
  iosEnabled: boolean,
  androidEnabled: boolean,
  createdAt: maybe(nullableNumber),
});

const isMobileAppLinkingConfig = objectOf({
  id: string,
  name: string,
  iosEnabled: boolean,
  androidEnabled: boolean,
  assignmentCount: number,
  createdAt: maybe(nullableNumber),
  assignments: arrayOf(isMobileAppLinkingAssignment),
});

export const isGetCompaniesCompanyIdMobileAppLinkingConfigsResult = objectOf({
  hits: number,
  results: arrayOf(isMobileAppLinkingConfig),
});
